import * as React from "react";
import * as _ from "lodash";
import {AbstractInputElement, FormElement} from "./FormInput";
import Datetime from 'react-datetime';
import "react-datetime/css/react-datetime.css";
import moment from "moment";
import {KitFieldKind} from "./kitFieldRegistry";

export interface Props extends FormElement<number,React.TextareaHTMLAttributes<any>>{
    timeFormat?: boolean | string;
    locale?: string;
    dateFormat?: boolean | string;
}
export class FormDateTimeInput extends AbstractInputElement<number,Props, {  }> {

    getDefaultValue() : number {
        return Date.now();
    }
    kind() : KitFieldKind {
        return "datetime";
    }
    // The raw model value: getModelValue() substitutes "now" for an empty model, which would
    // report a date the admin never picked.
    currentValue() : unknown {
        return this.props.modelValue;
    }
    dateChanged(value: moment.Moment | string) {
        if(typeof(value) != "string") {
            let time = value.toDate().getTime();
            this.onChange(time);
        }

    }

    render() {
        let selectedDateTime = new Date(this.getModelValue());
        let rest : React.TextareaHTMLAttributes<any> = _.omit(this.props,['validators',`model`, `fieldSet`, `modelValue`, `valid`, 'validationMap']);
        // Datetime does not forward unknown props; inputProps is the way onto its visible text input.
        let inputProps = { "data-model": this.props.model, "data-field-id": this.fieldId } as React.HTMLProps<HTMLInputElement>;
        return <Datetime  locale={this.props.locale} dateFormat={this.props.dateFormat} timeFormat={this.props.timeFormat} value={selectedDateTime} onChange={(value) => this.dateChanged(value)} inputProps={inputProps}/>
   }

}

